import React from "react";

import WComponent from "../common/WComponent";
import PlaybookBuildService from "../../services/PlaybookBuildService";
import PlaybookReasonForm from "./PlaybookReasonForm";

import "./playbook-build-page.css";

class PlaybookDraftLineCoverage extends WComponent {
	constructor(props) {
		super(props);
		this.state = {
			waivingCode: null,
		};
	}

	onStartWaiving = ({ code }) => {
		this.update({ waivingCode: code });
	};

	onStopWaiving = () => {
		this.update({ waivingCode: null });
	};

	onSaveWaiver = async ({ reason }) => {
		const { waivingCode } = this.state;
		const isSaved = await this.props.onWaive({ canonicalCode: waivingCode, reason });
		if (isSaved) await this.update({ waivingCode: null });
		return isSaved;
	};

	renderLineAction({ line }) {
		const { isOpen, isSaving, onClearWaiver } = this.props;
		const { waivingCode } = this.state;
		if (!isOpen) return null;
		if (waivingCode === line.code)
			return (
				<PlaybookReasonForm
					placeholder="Why does this line need no check?"
					saveLabel="Save waiver"
					isSaving={isSaving}
					onSave={this.onSaveWaiver}
					onCancel={this.onStopWaiving}
				/>
			);
		if (line.isWaived)
			return (
				<button type="button" className="tk-text-action tk-text-action--muted playbook-build__line-action" onClick={() => onClearWaiver({ canonicalCode: line.code })} disabled={isSaving}>
					Remove waiver
				</button>
			);
		if (!line.isUnchecked) return null;
		return (
			<button type="button" className="tk-text-action playbook-build__line-action" onClick={() => this.onStartWaiving({ code: line.code })} disabled={isSaving || !!waivingCode}>
				Waive with a reason
			</button>
		);
	}

	render() {
		const { lineCoverage } = this.props;
		const { title, lines } = PlaybookBuildService.describeDraftLines({ lineCoverage });
		if (lines.length === 0) return null;

		return (
			<div className="playbook-build__judgments">
				<span className="tk-text-strong">{title}</span>
				<ul className="playbook-build__judgment-list">
					{lines.map(line => (
						<li key={line.code} className="playbook-build__judgment">
							<span>
								{line.isUnchecked && <span className="playbook-build__judgment-gap" title="No check is about this line" />}
								{line.name}
							</span>
							<span className="playbook-build__judgment-facts">{line.detail}</span>
							{this.renderLineAction({ line })}
						</li>
					))}
				</ul>
			</div>
		);
	}
}

export default PlaybookDraftLineCoverage;
